<template>

    <div>
        <link href="/themes/web/assets/css/unit-detail.css" rel="stylesheet" />

        <div class="container">

            <div id="page-header-fixed">
                <div class="">
                    <div id="page-header" class="d-flex">
                        <ul class="breadcrumb flex">
                            <li @click="$router.go(-1)" class="icon"><img src="/themes/web/assets/images/back-to.svg" alt=""></li>
                            <li class="active">Assignment - {{name_lesson}}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <template v-if="is_page_list">
                <div class="card card-daily-challenge">
                    <div class="card-header d-flex">
                        <div class="card-title flex">{{ $t('assignments') }} ({{assignments.length}})</div>
                        <!-- <div class="buttons">
                            <div class="btn-group">
                                <button type="button" :class="display_type == 'all'?'btn btn-default active':'btn btn-default'" @click="setDisplayType('all')">All</button>
                                <button type="button" :class="display_type == 'incomplete'?'btn btn-default active':'btn btn-default'" @click="setDisplayType('incomplete')">Incomplete</button>
                            </div>
                        </div> -->
                    </div>
                    <div class="card-body">

                        <div id="assginment">
                            <div class="row">
                                <template v-for="(assignment, index) in assignments">
                                    <assigment-item :assignment="assignment" :index = "index + 1" :lesson_id = "lesson_id" @showAssignmentDetail = "showAssignmentDetail" />
                                </template>     
                            </div>
                        </div>

                    </div>
                </div>                
            </template>
            <template v-else>
                <div class="mark-lesson"></div>
                <div class="card">
                    <div class="pratice">
                        <div class="lesson-action-button" @click="is_page_list = true">
                            <span>+</span>
                        </div>
                        <div class="card-content" style="height: calc(100vh - 285px); padding: 0px; min-height: 550px;">
                            <!--<iframe width="100%" height="100%" src="/themes/web/assignments-4.html" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                            <iframe width="100%" height="100%" :src="assignment.url" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>                   
            </template>


        </div>
    </div>

</template>

<script>
import axios from "axios";
import { getAssignments } from '../../models/assignment';
import AssigmentItem from './AssigmentItem.vue';

export default {
  components: { AssigmentItem },
    name: "Assignment",
    title: "Assignment",

    data() {
        return {
            name_lesson: '',
            display_type: 'all',
            assignments: [],
            all_assignments: [],
            is_page_list: true,
            assignment: null,
        };
    },

    computed: {
        user_info() {
            return this.$store.state.user_info;
        },
    },

    created() {
       this.fetch();
    },

    methods: {
        fetch() {
            const {lesson_id} = this.$route.params;

            this.lesson_id = lesson_id;

            this.getAssignments();
        },

        setDisplayType(display_type){
            this.display_type = display_type;

            if(display_type == 'incomplete'){
                const assignments = [];
                this.all_assignments.forEach((a)=>{
                    if(a.status != 4){
                        assignments.push(a);
                    }
                });

                this.assignments = assignments;
            }else{
                this.assignments = this.all_assignments;
            }
        },

        async getAssignments() {
            const that = this;

            that.isLoading = true;

            await axios.all([
                getAssignments({
                    lesson_id: that.lesson_id
                }),
            ]).then(axios.spread((response) => {
                that.isLoading = false;

                if (response.data.code != 0) {
                    return;
                }

                that.name_lesson = response.data.results.name_lesson;
                that.assignments = response.data.results.assignments || [];
                that.all_assignments = response.data.results.assignments || [];
            }));
        },    
        
        showAssignmentDetail(assignment){
            this.assignment = assignment;

            this.is_page_list = false;
        }        
    },
};
</script>

<style scoped>
    /* .container{
        width: 940px;
        padding: 0;
    } */
</style>
